import MDInput from "components/Basics/MDInput";

/**
 * Scrollable text area component
 * This component provides a text area that allows for scrolling when the content exceeds the visible area.
 * @param {Object} props - Component properties
 * @param {string} props.value - The value of the text area.
 * @param {Function} [props.onChange] - Function to call when the value changes.
 * @returns {JSX.Element} The rendered component.
 */
const TextAreaScrollable = ({ value, onChange = () => {}, ...props }) => {
	return (
		<MDInput
			multiline
			value={value}
			onChange={onChange}
			fullWidth
			sx={{
				display: "flex",
				flex: 1,
				"& .MuiInputBase-root": {
					height: "100%",
					display: "flex",
					"& .MuiInputBase-input": {
						flex: 1,
						overflow: "auto !important",
						height: "100% !important",
						padding: "0px 10px !important"
					}
				}
			}}
			{...props}
		/>
	);
};

export default TextAreaScrollable;
